/**
 * Close header menus when the 990px desktop/tablet split flips.
 * Dawn HeaderDrawer only updates CSS vars on resize — leftover details[open]
 * leave Shop/Help or the hamburger in a dead state after the window changes.
 */
(function () {
  'use strict';

  var MQ = '(min-width: 990px)';
  var lastDesktop = null;

  function isDesktop() {
    try {
      return window.matchMedia(MQ).matches;
    } catch (e) {
      return window.innerWidth >= 990;
    }
  }

  function closeHeaderMenus() {
    document.querySelectorAll('.header__inline-menu details[open], header-menu details[open]').forEach(function (d) {
      d.removeAttribute('open');
      d.classList.remove('menu-opening');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }

  function closeMobileDrawer() {
    var host = document.querySelector('header-drawer');
    if (!host) return;
    var details = host.querySelector('details[open]');
    if (!details) return;
    var summary = details.querySelector('summary');
    if (summary && typeof host.closeMenuDrawer === 'function') {
      host.closeMenuDrawer({ type: 'resize' }, summary);
      return;
    }
    details.removeAttribute('open');
    details.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
    var header = document.querySelector('.section-header');
    if (header) header.classList.remove('menu-open');
  }

  function closeSearch() {
    document.querySelectorAll('details-modal.header__search details[open], .header__search details[open]').forEach(function (d) {
      d.removeAttribute('open');
    });
  }

  function onResize() {
    var desktop = isDesktop();
    if (lastDesktop === null) {
      lastDesktop = desktop;
      return;
    }
    if (desktop === lastDesktop) return;
    lastDesktop = desktop;
    closeHeaderMenus();
    closeSearch();
    if (desktop) closeMobileDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      lastDesktop = isDesktop();
    });
  } else {
    lastDesktop = isDesktop();
  }
  window.addEventListener('resize', onResize);
})();
